// Single source of truth for conference sponsors.
// Used by the homepage marquee (SponsorsSection) and the /sponsors page.
//
// Each sponsor has either a single `img`/`alt` pair or a `logos` array when
// multiple organisations share one sponsorship (e.g. Confirma + FYFE Asia).

export const TIER_ORDER = ['Diamond', 'Platinum', 'Gold', 'Silver', 'Bronze'];

export const sponsors = [
  {
    img: '/images/sponsor-TEQ.png',
    alt: 'Tourism and Events Queensland',
    name: 'Tourism and Events Queensland',
    url: 'https://teq.queensland.com',
    tier: 'Diamond',
  },
  {
    img: '/images/sponsor-gmc.jpg',
    alt: 'GUANGZHOU FIRST CONSTRUCTION GROUP CO., LTD.',
    name: 'GUANGZHOU FIRST CONSTRUCTION GROUP CO., LTD.',
    url: '',
    tier: 'Platinum',
  },
  {
    img: '/images/sponsor-WohHup.png',
    alt: 'Woh Hup (Private) Limited',
    name: 'Woh Hup (Private) Limited',
    url: 'https://www.wohhup.com',
    tier: 'Gold',
  },
  {
    img: '/images/sponsor-NetZero.png',
    alt: 'ARC Research Hub for Infrastructure Net Zero',
    name: 'ARC Research Hub for Infrastructure Net Zero',
    url: 'https://www.monash.edu/arc-netzero',
    tier: 'Gold',
  },
  {
    img: '/images/sponsor-redfox.png',
    alt: 'Red Fox Advisory',
    name: 'Red Fox Advisory',
    url: 'https://www.redfoxadvisory.com',
    tier: 'Silver',
  },
  {
    img: '/images/sponsor-TRADE%20ACTIVE%20CAMEROON%20SA.png',
    alt: 'TRADE ACTIVE CAMEROON SA',
    name: 'TRADE ACTIVE CAMEROON SA',
    url: '',
    tier: 'Silver',
  },
  {
    logos: [
      { img: '/images/sponsor-confirma.jpg', alt: 'Confirma Pty Ltd' },
      { img: '/images/sponsor-FYFE.png', alt: 'FYFE Asia' },
    ],
    alt: 'Confirma Pty Ltd',
    name: 'Confirma Pty Ltd',
    url: 'https://confirma.com.au',
    tier: 'Gold',
  },
  {
    img: '/images/sponsor-strucomp-technolab.jpg',
    alt: 'Strucomp Technolab',
    name: 'Strucomp Technolab',
    url: 'https://www.strucomp.com',
    tier: 'Bronze',
  },
  {
    img: '/images/sponsor-ARC.png',
    alt: 'ARC Industrial Transformation Training Centre, Net-Zero Building Ecosystem Lifecycle – NØBEL',
    name: 'ARC Industrial Transformation Training Centre, Net-Zero Building Ecosystem Lifecycle – NØBEL',
    url: 'https://www.nobel.org.au',
    tier: 'Bronze',
  },
];

// Sponsors sorted Diamond -> Bronze (stable within a tier).
export const sortedSponsors = TIER_ORDER.flatMap((tier) =>
  sponsors.filter((sp) => sp.tier === tier)
);

// [{ tier, sponsors }] for tiers that have at least one sponsor.
export const sponsorTierGroups = TIER_ORDER.map((tier) => ({
  tier,
  sponsors: sponsors.filter((sp) => sp.tier === tier),
})).filter((group) => group.sponsors.length > 0);
